// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"1063e5dd","296":"aef829c2","361":"10817459","453":"57c3e370","537":"2eb33af3"}[chunkId] + ".chunk.js";
};